import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

export interface ICustomProperties {
    [key: string]: any;
}

export interface AuthClaims {
    customerId: string | undefined;
    userId: string | undefined;
}

export interface ReactInsightsLoggerInterface {
    logPageView(name?: string, url?: string): void;
    logEvent(name: string, properties?: ICustomProperties): void;
    logMetric(name: string, average: number, properties?: ICustomProperties): void;
    logException(exception: Error, severityLevel?: number, customProperties?: ICustomProperties): void;
    logTrace(message: string, properties?: ICustomProperties): void;
    logBrowserCapabilities(): void;
    setUserContext(claims: undefined | AuthClaims): void;
}

export class ReactInsightsLogger implements ReactInsightsLoggerInterface {
    constructor(
        private appInsights: ApplicationInsights | null,
        private reactPlugin: ReactPlugin | null,
    ) {}

    logPageView(name?: string, url?: string): void {
        if (this.appInsights) {
            this.appInsights.trackPageView({ name, uri: url });
        }
    }

    logEvent(name: string, properties?: ICustomProperties): void {
        if (this.appInsights) {
            this.appInsights.trackEvent({ name }, properties);
        }
    }

    logMetric(name: string, average: number, properties?: ICustomProperties): void {
        if (this.appInsights) {
            this.appInsights.trackMetric({ name, average }, properties);
        }
    }

    logException(exception: Error, severityLevel?: number, customProperties?: ICustomProperties): void {
        if (this.appInsights) {
            this.appInsights.trackException({ 
                exception,
                severityLevel 
            }, customProperties);
        }
    }

    logTrace(message: string, properties?: ICustomProperties): void {
        if (this.appInsights) {
            this.appInsights.trackTrace({ message }, properties);
        }
    }

    logBrowserCapabilities(): void {
        const capabilities = {
            userAgent: navigator.userAgent,
            language: navigator.language,
            platform: navigator.platform,
            cookieEnabled: navigator.cookieEnabled,
            onLine: navigator.onLine,
            screen: {
                width: screen.width,
                height: screen.height,
                colorDepth: screen.colorDepth
            }
        };
        
        this.logEvent('BrowserCapabilities', capabilities);
    }

    setUserContext(claims: undefined | AuthClaims): void {
        if (this.appInsights && claims) {
            this.appInsights.context.user.authenticatedId = claims.userId ?? '';
            this.appInsights.context.user.accountId = claims.customerId ?? '';
        }
    }
}